export default {
  'report.name': 'Report',
  'report.title': 'Report',
}